import { Forms } from './components/forms';

export class BaseApp {
  constructor() {
    if (typeof window.appSettings == 'undefined') {
      throw new Error('App settings not defined');
    }
    this.settings = window.appSettings;
    if (this.settings.env == 'production') {
      console.log = () => {};
    }
    this.forms = new Forms();
    this.initButtons();
    this.initLazysizes();
    this.initAccordions();
    this.init();
    document.querySelector('body').classList.add('loaded');
  }

  init() {
    console.error('BaseApp.init() not implemented');
  }

  initAccordions() {
    let triggers = document.querySelectorAll('[data-accordion]');
    for (let i = triggers.length - 1; i >= 0; i--) {
      setTimeout(() => {
        let id = triggers[i].dataset.accordion;
        let body = document.querySelector(id);
        let rotate = triggers[i].querySelector('.transform');
        if (body.classList.contains('open')) {
          body.style.height = body.scrollHeight + 'px';
          if (rotate) {
            rotate.classList.replace('rotate-90', '-rotate-90');
          }
        }
      }, 500);
      triggers[i].addEventListener('click', (e) => {
        e.preventDefault();
        let id = triggers[i].dataset.accordion;
        let body = document.querySelector(id);
        let rotate = triggers[i].querySelector('.transform');
        if (!body.classList.contains('open')) {
          let datagroup = triggers[i].dataset.accordionGroup;
          let groupBodies = document.querySelectorAll('[data-accordion-group="' + datagroup + '"]');
          groupBodies.forEach((groupBody) => {
            this.closeAccordion(groupBody.dataset.accordion);
          });
          if (rotate) {
            rotate.classList.replace('rotate-90', '-rotate-90');
          }
          body.style.height = body.scrollHeight + 'px';
          body.classList.add('open');
        } else {
          this.closeAccordion(id);
        }
      });
    }
  }

  closeAccordion(id) {
    let body = document.querySelector(id);
    let trigger = document.querySelector('[data-accordion="' + id + '"]');
    let rotate = trigger ? trigger.querySelector('.transform') : null;
    if (rotate) {
      rotate.classList.replace('-rotate-90', 'rotate-90');
    }
    body.style.height = '0px';
    body.classList.remove('open');
  }

  initButtons() {
    document.addEventListener(
      'click',
      (event) => {
        let button = event.target.closest('[data-button-url]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        let url = button.getAttribute('data-button-url');
        if (!url) return;
        let win = window.open(url, '_blank');
        win.focus();
      },
      false,
    );
  }

  initLazysizes() {
    document.addEventListener('lazyloaded', (e) => {
      e.target.parentNode.classList.add('image-loaded');
      e.target.parentNode.classList.remove('loading');
    });
  }

  disableScrolling() {
    document.body.classList.add('stop-scrolling');
  }

  enableScrolling() {
    document.body.classList.remove('stop-scrolling');
  }
}
